import { render, staticRenderFns } from "./WeaponSelectionModal.vue?vue&type=template&id=10c4cd40&scoped=true&"
import script from "./WeaponSelectionModal.vue?vue&type=script&lang=js&"
export * from "./WeaponSelectionModal.vue?vue&type=script&lang=js&"
import style0 from "./WeaponSelectionModal.vue?vue&type=style&index=0&id=10c4cd40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c4cd40",
  null
  
)

export default component.exports